/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Overviewgreetingevening2Inputs */

const en_overviewgreetingevening2 = /** @type {(inputs: Overviewgreetingevening2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Good evening, ${i?.name}`)
};

const de_overviewgreetingevening2 = /** @type {(inputs: Overviewgreetingevening2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Guten Abend, ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Good evening, {name}" |
*
* @param {Overviewgreetingevening2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const overviewgreetingevening2 = /** @type {((inputs: Overviewgreetingevening2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overviewgreetingevening2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_overviewgreetingevening2(inputs)
	return de_overviewgreetingevening2(inputs)
});
export { overviewgreetingevening2 as "overviewGreetingEvening" }